import {
  apiUrlEndpointFactory
} from "../chunk-TNXG6CPU.js";
import {
  logInfo
} from "../chunk-KTPUX2XH.js";
import "../chunk-X3MX6SC5.js";

// lib/paths/variant.ts
function isLoginUrl(obj) {
  return obj.login !== void 0 && (typeof obj.login.url === "string" || obj.login.url instanceof Location || obj.login.url === null);
}
function isNavigateEvent(obj) {
  return obj !== void 0 && typeof obj.handler === "function";
}

// lib/paths/paths.ts
var buildRedirectUri = (login) => {
  const base = new URL(login.login.url.toString(), window.location.href);
  base.searchParams.set("redirect_uri", window.location.href);
  return base;
};
var navigator = async (url) => {
  logInfo("Navigate to", url);
  if (isNavigateEvent(url)) {
    return {
      navigate: () => {
        url.handler(url);
      }
    };
  }
  if (isLoginUrl(url)) {
    return {
      navigate: () => {
        logInfo("Navigating to", url.login.url.toString());
        window.location.assign(url.login.url.toString());
      }
    };
  }
  return await Promise.reject(new Error("Invalid type"));
};
var createBasicAppPaths = (apiVersion) => {
  const resolve = (...paths) => {
    return paths.reduce((result, item) => {
      if (!result.endsWith("/") && !item.startsWith("/")) {
        result += "/";
      }
      result += item;
      return result;
    }, "");
  };
  const Root = {
    root: {
      url: resolve(process.env.PUBLIC_PATH ?? "/")
    }
  };
  const rootUrl = Root.root.url.toString();
  const LoginApiUrl = {
    login: {
      api: {
        url: apiUrlEndpointFactory(apiVersion, Root, "auth/login").endpoint
      }
    }
  };
  const LoginPage = {
    login: { url: resolve(Root.root.url.toString(), "l") }
  };
  const LoginSuccessPage = {
    login: {
      success: {
        url: resolve(
          LoginPage.login.url.toString(),
          `success?cacheBust=${process.env.BUILD_NUMBER}`
        ),
        router: resolve(LoginPage.login.url.toString(), "success")
      }
    }
  };
  const LoginFailedPage = {
    login: { failed: { url: `${LoginPage.login.url.toString()}?failed` } }
  };
  const LegacyFancyLoginPage = resolve(rootUrl, "l/f");
  const LegacyLoginSuccess = resolve(rootUrl, "login/success");
  const LegacyLoginFailed = resolve(rootUrl, "login/failed");
  return {
    Root,
    LoginApiUrl,
    LoginPage,
    LoginSuccessPage,
    LoginFailedPage,
    Legacy: {
      LegacyFancyLoginPage,
      LegacyLoginSuccess,
      LegacyLoginFailed
    },
    resolve
  };
};
export {
  buildRedirectUri,
  createBasicAppPaths,
  isLoginUrl,
  navigator
};
